import Vue from 'vue';
import Vuex from 'vuex';
import { alert } from './alert.module';
import { library } from './library.module';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    alert,
    library
  }
});



// WEBPACK FOOTER //
// ./source/store/index.js